const getContrastYIQ = (hex) => {
  const hexcolor = hex.replace("#", '');
  const r = parseInt(hexcolor.substr(0,2),16);
  const g = parseInt(hexcolor.substr(2,2),16);
  const b = parseInt(hexcolor.substr(4,2),16);
  const yiq = ((r*299)+(g*587)+(b*114))/1000;
  const rate = 1.6
  return (yiq >= 128 * rate) ? '#000000' : '#FFFFFF';
}

export default getContrastYIQ;


// WEBPACK FOOTER //
// ./src/utils/getContrastYIQ.js